"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _TextField = _interopRequireDefault(require("../TextField"));

var _styledComponents = require("styled-components");

var _Theme = _interopRequireDefault(require("../Theme"));

var _DesktopInput = _interopRequireDefault(require("./DesktopInput"));

var _MobileInput = _interopRequireDefault(require("./MobileInput"));

var _dateFns = require("date-fns");

var _constant = require("./constant");

var _DateInput = _interopRequireDefault(require("./DateInput.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var DateInput = function DateInput(_ref) {
  var accessible = _ref.accessible,
      customProperties = _ref.customProperties,
      theme = _ref.theme,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      label = _ref.label,
      value = _ref.value,
      dateFormat = _ref.dateFormat,
      validateStatus = _ref.validateStatus,
      validateMessage = _ref.validateMessage,
      isMobile = _ref.isMobile,
      placeholder = _ref.placeholder,
      className = _ref.className,
      disabled = _ref.disabled,
      hideBorder = _ref.hideBorder,
      dateObj = _ref.dateObj,
      shortDaysTranslation = _ref.shortDaysTranslation,
      iconFront = _ref.iconFront,
      icon = _ref.icon,
      onIconClick = _ref.onIconClick,
      variableWidth = _ref.variableWidth,
      labelMarginBottomLarge = _ref.labelMarginBottomLarge,
      alignContentRight = _ref.alignContentRight,
      isOnlyApplyForHotel = _ref.isOnlyApplyForHotel,
      borderRadius = _ref.borderRadius,
      containerBoxSizing = _ref.containerBoxSizing,
      enableFontSizeChange = _ref.enableFontSizeChange,
      validateIcon = _ref.validateIcon,
      disclaimer = _ref.disclaimer,
      showIcon = _ref.showIcon,
      disclaimerModal = _ref.disclaimerModal;
  var dateInputRef = (0, _react.useRef)(null);
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var textFieldCustomProperties = _objectSpread(_objectSpread({}, customProperties), {}, {
    dateFormat: dateFormat
  });

  var _useState = (0, _react.useState)(dateObj && _constant.DAY_ARRAY[(0, _dateFns.getDay)(dateObj)]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      dayref = _useState2[0],
      setdayref = _useState2[1];

  var _useState3 = (0, _react.useState)(shortDaysTranslation),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      shortDays = _useState4[0],
      setshortDays = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      day = _useState6[0],
      setDay = _useState6[1];

  (0, _react.useEffect)(function () {
    if (dayref && shortDays) {
      setDay(shortDays[dayref]);
    }
  }, [dayref, shortDays]);
  (0, _react.useEffect)(function () {
    if (dateObj) {
      setdayref(_constant.DAY_ARRAY[(0, _dateFns.getDay)(dateObj)]);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [dateObj]);
  (0, _react.useEffect)(function () {
    setshortDays(shortDaysTranslation);
  }, [shortDaysTranslation]);
  (0, _react.useEffect)(function () {
    if (dateInputRef && dateInputRef.current) {
      dateInputRef.current.addEventListener('click', function (e) {
        if (e.target.tagName.toLowerCase() === 'div' || e.target.tagName.toLowerCase() === 'path' || e.target.tagName.toLowerCase() === 'svg') {
          // for Android
          dateInputRef.current.querySelector('input').click(); // for iOS

          dateInputRef.current.querySelector('input').focus();
        }
      });
    }
  }, [dateInputRef]);
  var inputComponent = isMobile ? _MobileInput.default : _DesktopInput.default;

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_TextField.default, {
      innerRef: dateInputRef,
      theme: theme,
      className: className,
      alwaysShowLabel: true,
      accessible: accessible,
      label: label,
      customProperties: textFieldCustomProperties,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      placeholder: placeholder || dateFormat,
      inputComponent: inputComponent,
      icon: isMobile ? 'DateRangeIcon' : icon,
      onIconClick: onIconClick,
      validateStatus: validateStatus,
      validateMessage: validateMessage,
      validateIcon: validateIcon,
      value: value,
      disabled: disabled,
      hideBorder: hideBorder,
      day: day,
      iconFront: iconFront,
      variableWidth: variableWidth,
      labelMarginBottomLarge: labelMarginBottomLarge,
      alignContentRight: alignContentRight,
      isOnlyApplyForHotel: isOnlyApplyForHotel,
      borderRadius: borderRadius,
      isDate: true,
      containerBoxSizing: containerBoxSizing,
      enableFontSizeChange: enableFontSizeChange,
      disclaimer: disclaimer,
      showIcon: showIcon,
      disclaimerModal: disclaimerModal
    });
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

DateInput.propTypes = _DateInput.default.PropTypes;
DateInput.defaultProps = _DateInput.default.DefaultProps;
var _default = DateInput;
exports.default = _default;